import styled from "styled-components";
import { styled as styledMui } from "@mui/system";
import { Button, Typography, TextField } from "@mui/material";
import { visuallyHidden } from "../../styles/Common.styled";

export const Logo = styled.img`
  max-width: 400px;
  margin: 0 auto;
  display: block;
  width: 100%;
  margin-bottom: -105px;
`;

export const Form = styled.form`
  background-color: #fff;
  padding: 48px;
  padding-bottom: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-shadow: 0 0 15px 0px rgb(0 0 0 / 10%);
  max-width: 350px;
  width: 100%;
  margin-inline: auto;
  padding-top: 80px;
`;

export const LoginButton = styledMui(Button)({
  fontFamily: "Montserrat, sans-serif",
  fontWeight: 600,
  marginTop: 20,
  backgroundColor: "#121212",
  color: "#fff",

  "&:hover": {
    backgroundColor: "#231b94",
  },
});

export const Title = styledMui(Typography)`
  ${visuallyHidden}
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #121212;
  position: relative;
`;

export const ContainerForm = styled.div`
  animation: fadeIn 1s ease-in-out;
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const InputStyled = styledMui(TextField)`
  color: #121212;

  & .MuiInputBase-root.MuiInput-root,
  & .MuiInputLabel-root,
  & .MuiInputLabel-root.Mui-focused {
    color: #121212;
  }

  && .MuiInputBase-input {
    color: #121212;
    -webkit-text-fill-color: #121212;
    background-color: transparent;
    color-scheme: light;
  }

  /* Browser autofill paints its own background: cover it with the card's white */
  && .MuiInputBase-input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 100px #fff inset;
    box-shadow: 0 0 0 100px #fff inset;
    caret-color: #121212;
  }

  & .MuiInputAdornment-root .MuiSvgIcon-root {
    color: rgba(18, 18, 18, 0.6);
  }


  & .MuiInputBase-root.MuiInput-root::after {
    border-color: #241c94;
  }

  & .MuiInputBase-root.MuiInput-root::before {
    border-color:rgba(18, 18, 18, 0.60);
  }
`;


export const AppName = styled.div`
    color: #000;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    line-height: normal;
    letter-spacing: 0.1em;
    text-align: center;
    font-weight: 700;
    font-size: 16px;
    width: 100%;
    padding: 16px;
    text-transform: uppercase;
`;